import { Button, Modal, Result } from "antd";
import React, { useState } from "react";
import { requestsZAPI } from "../../../request";
import { ModalErrorSign } from "../error";
import { colors } from "../../../../../Utils/temas";
import { useUserContext } from "../../../../../contexts/usersContext";

export const ModalSignInstance = ({
  visible,
  onCancel,
  onConfirm,
  token,
  id,
}) => {
  const { currentUser } = useUserContext();

  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);

  const signInstance = async () => {
    setLoading(true);
    try {
      const response = await requestsZAPI.signInstance(id, token);
      if (response.status === 200) {
        onCancel();
        onConfirm();
        setLoading(false);
      }
    } catch (error) {
      onCancel();
      setOpenError(true);
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        footer={
          currentUser.is_support
            ? null
            : [
                <Button onClick={onCancel}>Cancelar</Button>,
                <Button
                  loading={loading}
                  onClick={signInstance}
                  style={{
                    background: colors.secondary,
                    color: "white",
                    fontWeight: "500",
                  }}
                >
                  Confirmar
                </Button>,
              ]
        }
      >
        {currentUser.is_support ? (
          <Result
            status={"500"}
            title="Sem permissão"
            subTitle="Opa, você não tem permissão para realizar esta ação."
            extra={
              <Button
                type="primary"
                style={{ fontWeight: "500" }}
                onClick={onCancel}
              >
                Voltar
              </Button>
            }
          />
        ) : (
          <text style={{ fontSize: 20, fontWeight: "700" }}>
            Gostaria de assinar esta instância?
          </text>
        )}
      </Modal>

      <ModalErrorSign
        onCancel={() => setOpenError(false)}
        visible={openError}
      />
    </>
  );
};
